import React from 'react';

const ErrorText: React.FC = () => (
  <p className="t-align-center">
    There was an error. Please try refreshing the page
  </p>
);

export default ErrorText;
